module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "TitlePage"
  }, [_c('h1', [_vm._v("Excellence in Preaching")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "Author sgc-1"
  }, [_vm._v("Studying the Craft of Leading Preachers")]), _vm._v(" "), _c('p', {
    staticClass: "Author sgc-1"
  }, [_vm._v("Simon Vibert")])]), _vm._v(" "), _c('p', {
    staticClass: "IVPcenter"
  }, [_c('img', {
    attrs: {
      "alt": "IVP Books Imprint",
      "src": "Images/IVP_Books_Quarter.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "IVPcenter"
  }, [_c('a', {
    attrs: {
      "href": "http://www.IVPress.com/books/",
      "target": "_blank"
    }
  }, [_vm._v("www.IVPress.com/books")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d043d97","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TitlePage.vue
// module id = 60
// module chunks = 0